const __DEFAULT_PAGE_SIZE__ = 10;
export async function searchRequest(endpoint, options) {
    const params = new URLSearchParams();
    const pageSize = options.pageSize || __DEFAULT_PAGE_SIZE__;
    params.append('ContentType', options.contentType);
    params.append('q', options.q);
    params.append('PageSize', pageSize.toString());
    params.append('From', options.from.toString());
    if (!!options.parentPage) {
        params.append('ParentPage', String(options.parentPage));
    }
    const url = `${endpoint}?${params}`;
    const response = await fetch(url);
    return response.json();
}
